import React, { useEffect, useRef, useState } from "react";
import { SVVTextInput } from "@komponentkassen/svv-form";
import { useApptekster } from "../../apptekst-context";
import {
  isValidEmail,
  isValidPhoneNumber,
  trimPhoneNumber,
} from "../../helpers/InputValidators";
import { SVVInformationMessage } from "@komponentkassen/svv-information-message";
import {
  SVVButtonRow,
  SVVButton
} from "@komponentkassen/svv-button";
import { useNavigate } from "react-router-dom";
import api from "../../helpers/api";
import {SVVBodyText, SVVHeading} from "@komponentkassen/svv-text";
import "./reconfirm.scss"

const ResendBooking = () => {
  const t = useApptekster();
  const navigate = useNavigate();
  const [emailOrPhoneNumber, setEmailOrPhoneNumber] = useState<string>("");
  const [triedToSubmit, setTriedToSubmit] = useState<boolean>(false);
  const [fetchingError, setFetchingError] = useState<boolean>(false);
  const [isFetching, setIsFetching] = useState<boolean>(false);

  const emailOrPhoneValid: boolean = emailOrPhoneNumber.includes("@")
    ? isValidEmail(emailOrPhoneNumber)
    : isValidPhoneNumber(trimPhoneNumber(emailOrPhoneNumber)) &&
      emailOrPhoneNumber !== "";

  const headingRef = useRef<HTMLHeadingElement | null>(null);

  useEffect(() => {
    if (headingRef?.current) {
      headingRef.current?.focus();
    }
  }, [headingRef]);

  const submit = (event: any) => {
    const url: string = "/resend/resendbekreftelse";
    event.preventDefault();
    setTriedToSubmit(true);

    if (emailOrPhoneValid) {
      setFetchingError(false);
      setIsFetching(true);
      api
        .post(
          `/api/Timebestilling/booking/resendconfirmation?emailOrPhone=${trimPhoneNumber(emailOrPhoneNumber)}`
        )
        .then((response) => {
          navigate(url);
          setIsFetching(false);
        })
        .catch((error) => {
          setIsFetching(false);
          setFetchingError(true);
          console.log(error);
        });
    }
  };

  return (
    <form 
      onSubmit={submit} 
      className="reconfirm__form"
      noValidate
    >
      <SVVHeading 
        level="h2" 
        ref={headingRef} 
        tabIndex={-1}
      >
        {t("timebestilling.send-bekreftelse-paa-nytt")}
      </SVVHeading>
      <SVVBodyText>
        {t("timebestilling.har-du-bestilt-time")}
      </SVVBodyText>
      <div className="spacing-bottom--small">
        <SVVTextInput
          label={t("timebestilling.epost-eller-mob-label")}
          id="emailOrPhone"
          onChange={(e) => setEmailOrPhoneNumber(e.target.value)}
          inputSize="large"
          errorMessage={
            !emailOrPhoneValid && triedToSubmit
              ? t("timebestilling.fyll-inn-epost-eller-mob")
              : ""
          }
          value={emailOrPhoneNumber}
          required
        />
      </div>

      <div aria-live="assertive">
        {fetchingError && (
          <SVVInformationMessage type="error">
            <p>{t("timebestilling.noe-gikk-galt")}</p>
          </SVVInformationMessage>
        )}
      </div>

      <SVVButtonRow>
        <SVVButton 
          type={"submit"} 
          color="secondary" 
          disabled={isFetching} 
          loading={isFetching}
        >
          {t("timebestilling.send-bekreftelse")}
        </SVVButton>
      </SVVButtonRow>
    </form>
  );
};

export default ResendBooking;
